export default __webpack_public_path__ + "static/media/eb-pro-wht-banner-3.1fb7aee1.jpg";